import React, { useContext, useState } from "react";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";
import DataTable from "../../components/Elements/DataTable/DataTable";

import AdminEditWalletModal from "../../components/AdminPages/AdminEditWalletModal";

import { AuthContext } from "../../context/AuthContext";
import WalletService from "../../services/WalletService";

import editIcon from "../../assets/data/edit.png";
import deleteIcon from "../../assets/data/delete.png";

// Always visible wallet columns
const alwaysVisibleColumns = [
  { key: "id", label: "Wallet ID" },
  { key: "balance", label: "Balance" },
  { key: "currency", label: "Currency" },
  { key: "user_id", label: "User" },
];

// Optional columns
const optionalColumns = [{ key: "carrier_id", label: "Carrier ID" }];

// Sort options
const sortOptions = [
  { value: "id", label: "Wallet ID" },
  { value: "balance", label: "Balance" },
  { value: "user_id", label: "User" },
  { value: "currency", label: "Currency" },
];

// Filters
const filterDefinitions = [
  { key: "id", label: "Wallet ID", type: "text" },
  { key: "user_id", label: "User Email", type: "text" },
  { key: "carrier_id", label: "Carrier ID", type: "text" },
  { key: "balance", label: "Balance", type: "text" },
  {
    key: "currency",
    label: "Currency",
    type: "select",
    options: [
      { value: "EUR", label: "EUR" },
      { value: "USD", label: "USD" },
      { value: "GBP", label: "GBP" },
    ],
  },
];

// Custom renderers
const customRenderers = {
  balance: (item) => {
    if (item.balance === null || item.balance === undefined) return "-";
    return `${item.balance.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  },
};

const AdminWallets = () => {
  const { token } = useContext(AuthContext); // token kept for future auth use
  const [dataVersion, setDataVersion] = useState(0);
  const [editingWallet, setEditingWallet] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  const fetchDataFn = (params) => WalletService.fetchWalletsAdmin(params);

  const handleEdit = (wallet) => {
    setEditingWallet(wallet);
    setShowEditModal(true);
  };

  const handleUpdated = () => {
    setShowEditModal(false);
    setEditingWallet(null);
    setDataVersion((v) => v + 1);
  };

  const handleDelete = async (wallet) => {
    if (!window.confirm(`Delete wallet ${wallet.id}?`)) return;
    try {
      await WalletService.deleteWallet(wallet.id);
      setDataVersion((v) => v + 1);
    } catch (err) {
      alert(err.message || "Failed to delete wallet");
    }
  };

  const walletRowActions = [
    { label: "Edit", icon: editIcon, onClick: handleEdit },
    { label: "Delete", icon: deleteIcon, onClick: handleDelete },
  ];

  return (
    <div className="admin-wallets-page">
      <PageHeader title="Wallets" description="View all wallets" />

      <DataTable
        key={dataVersion}
        tableId="admin-wallets"
        fetchDataFunction={fetchDataFn}
        columns={alwaysVisibleColumns}
        optionalColumns={optionalColumns}
        sortOptions={sortOptions}
        filterDefinitions={filterDefinitions}
        defaultSortBy="id"
        itemKey="id"
        customRenderers={customRenderers}
        rowActions={walletRowActions}
        showCheckboxes={false}
        showFilters={true}
        showPageSize={true}
      />

      <AdminEditWalletModal
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        wallet={editingWallet}
        onUpdated={handleUpdated}
      />
    </div>
  );
};

export default AdminWallets;
